import { VueConstructor } from 'vue/types/umd'
import CareersLogo from './CareersLogo/CareersLogo.vue'
import CompetenciesLogo from './CompetenciesLogo/CompetenciesLogo.vue'
import LearningLogo from './LearningLogo/LearningLogo.vue'
import PerformanceLogo from './PerformanceLogo/PerformanceLogo.vue'
import SuccessionLogo from './SuccessionLogo/SuccessionLogo.vue'
import TalentLogo from './TalentLogo/TalentLogo.vue'
import TedsLogo from './TedsLogo/TedsLogo.vue'
import TedsAdministratorLogo from './TedsAdministratorLogo/TedsAdministratorLogo.vue'
import TedsEveryoneLogo from './TedsEveryoneLogo/TedsEveryoneLogo.vue'
import TedsAnalyticsLogo from './TedsAnalyticsLogo/TedsAnalyticsLogo.vue'
import ScormLogo from './ScormLogo/ScormLogo.vue'
import RecruitingLogo from './RecruitingLogo/RecruitingLogo.vue'

/**
 * Loads all of the logo components in one place to make
 * loading the application and testing the application less
 * bloated.
 * @param Vue
 */
export function loadLogoComponents(Vue: VueConstructor): void {
  Vue.component('CareersLogo', CareersLogo)
  Vue.component('CompetenciesLogo', CompetenciesLogo)
  Vue.component('LearningLogo', LearningLogo)
  Vue.component('PerformanceLogo', PerformanceLogo)
  Vue.component('SuccessionLogo', SuccessionLogo)
  Vue.component('TalentLogo', TalentLogo)
  Vue.component('TedsLogo', TedsLogo)
  Vue.component('TedsAdministratorLogo', TedsAdministratorLogo)
  Vue.component(`TedsEveryoneLogo`, TedsEveryoneLogo)
  Vue.component(`TedsAnalyticsLogo`, TedsAnalyticsLogo)
  Vue.component(`ScormLogo`, ScormLogo)
  Vue.component('RecruitingLogo', RecruitingLogo)
}
